module.exports = __webpack_public_path__ + "static/media/latinCallig.ddc39f61.jpeg";